import { Redirect } from "react-router-dom";

import { useAuthInfo } from "../../context/AuthContext";

const SecurityWrapper = ({
  requiredPermissions = [],
  requiredRoles = [],
  children,
  redirect = false,
}) => {
  const { userInfo } = useAuthInfo();

  if (userInfo.role.name === "super-admin") {
    return children;
  }

  if (requiredRoles.length > 0 && !requiredRoles.includes(userInfo.role.name)) {
    return redirect ? <Redirect to="/dashboard" /> : null;
  }

  if (requiredPermissions.length > 0) {
    const hasRequiredPermissions = requiredPermissions.every((perm) =>
      userInfo.role.permissions.some((permission) => permission.name === perm)
    );
    if (!hasRequiredPermissions) {
      return redirect ? <Redirect to="/dashboard" /> : null;
    }
  }

  return children;
};

export default SecurityWrapper;
